"use client";

import "./styles.css";

function Policy() {
  return (
    <div className="style-0">
      <div className="style-1">
        <div className="style-2">
          <div className="style-3">
            <h4 className="style-4">Política de Privacidade</h4>
            <h4 className="style-5">1. INTRODUÇÃO</h4>
            <div className="style-6">
              Esta Política de Privacidade descreve como a YINFLOW LTDA, pessoa jurídica de Direito Privado,
              inscrita no CNPJ sob o nº 42.516.954/0001-00, estabelecida na Avenida Brigadeiro Faria Lima, nº
              2369, Conj. 1102 - Bairro: Jardim Paulistano, São Paulo/SP - CEP 01452922, coleta, usa e protege
              os dados pessoais dos USUÁRIOS que acessam e utilizam as funcionalidades e serviços do site
              Yinflow.Life (disponível em{" "}
              <a href="https://yinflow.life/" className="style-7">
                https://yinflow.life/
              </a>
              ). Esta política está em conformidade com a Lei Federal nº 12.965, de 23 de abril de 2014 (Marco
              Civil da Internet) e a Lei Federal nº 13.709, de 14 de agosto de 2018 (Lei de Proteção de Dados
              Pessoais). Todos os dados mencionados nesta política são tratados com base em boas práticas de
              gestão de tecnologias da informação que envolvem todo tipo de operação de acesso, processamento,
              armazenamento e compartilhamento de dados, tendo todos os seus sistemas sendo gerenciados por
              profssionais competentes e certificados para atuação em suas respectivas funções.
            </div>

            <h4 className="style-8">2. COLETA E USO DE DADOS</h4>
            <div className="style-9">
              <strong className="style-10">2.1.</strong> Nós obtemos seus dados pessoais através de seu
              cadastro realizado no ato de seu registro ou uso de nossos serviços. Quando você se registra em
              nossa plataforma ou aplicativo, pedimos que forneça dados básicos, incluindo seu nome, endereço
              de e-mail.
            </div>
            <div className="style-11">
              <strong className="style-12">2.2.</strong> Você também poderá adicionar informações que incluem,
              mas não se limitam a:
            </div>
            <ul role="list" className="style-13">
              <li className="style-14">
                <div className="style-15">
                  <strong className="style-16">Dados Demográfico</strong>{" "}
                </div>
              </li>
            </ul>
            <ul role="list" className="style-17">
              <li className="style-18">
                <div className="style-19">Nome</div>
              </li>
              <li className="style-20">
                <div className="style-21">Sobrenome</div>
              </li>
              <li className="style-22">
                <div className="style-23">Estado civil</div>
              </li>
              <li className="style-24">
                <div className="style-25">Data de nascimento</div>
              </li>
              <li className="style-26">
                <div className="style-27">CPF</div>
              </li>
            </ul>
            <ul role="list" className="style-28">
              <li className="style-29">
                <div className="style-30">
                  <strong className="style-31">Dados de Endereço</strong>
                </div>
              </li>
            </ul>
            <ul role="list" className="style-32">
              <li className="style-33">
                <div className="style-34">Município</div>
              </li>
              <li className="style-35">
                <div className="style-36">Município</div>
              </li>
              <li className="style-37">
                <div className="style-38">Logradouro</div>
              </li>
              <li className="style-39">
                <div className="style-40">Número</div>
              </li>
              <li className="style-41">
                <div className="style-42">Bairro</div>
              </li>
              <li className="style-43">
                <div className="style-44">Estado</div>
              </li>
            </ul>
            <ul role="list" className="style-45">
              <li className="style-46">
                <div className="style-47">
                  <strong className="style-48">Dados de Saúde</strong>
                </div>
              </li>
            </ul>
            <ul role="list" className="style-49">
              <li className="style-50">
                <div className="style-51">Formulário SOAP: Subjetivo, Objetivo, Avaliação, Plano de Ação</div>
              </li>
              <li className="style-52">
                <div className="style-53">Desfecho do episódio</div>
              </li>
              <li className="style-54">
                <div className="style-55">Prescrições</div>
                <ul role="list" className="style-56">
                  <li className="style-57">
                    <div className="style-58">a. Nome</div>
                  </li>
                  <li className="style-59">
                    <div className="style-60">b. Posologia</div>
                  </li>
                  <li className="style-61">
                    <div className="style-62">c. Uso contínuo</div>
                  </li>
                </ul>
              </li>
              <li className="style-63">
                <div className="style-64">Encaminhamentos </div>
                <ul role="list" className="style-65">
                  <li className="style-66">
                    <div className="style-67">Descrição</div>
                  </li>
                  <li className="style-68">
                    <div className="style-69">Especialidade</div>
                  </li>
                  <li className="style-70">
                    <div className="style-71">Informações de referência</div>
                  </li>
                </ul>
              </li>
              <li className="style-72">
                <div className="style-73">Requisições de exame</div>
                <ul role="list" className="style-74">
                  <li className="style-75">
                    <div className="style-76">Descrição da requisição</div>
                  </li>
                  <li className="style-77">
                    <div className="style-78">Observação</div>
                  </li>
                  <li className="style-79">
                    <div className="style-80">Procedimento</div>
                    <ul role="list" className="style-81">
                      <li className="style-82">
                        <div className="style-83">a. Nome</div>
                      </li>
                      <li className="style-84">
                        <div className="style-85">b. Grupo</div>
                      </li>
                      <li className="style-86">
                        <div className="style-87">c. Subgrupo</div>
                      </li>
                      <li className="style-88">
                        <div className="style-89">d. Observação</div>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li className="style-90">
                <div className="style-91">Documentos</div>
                <ul role="list" className="style-92">
                  <li className="style-93">
                    <div className="style-94">Receita</div>
                  </li>
                  <li className="style-95">
                    <div className="style-96">Exames</div>
                  </li>
                  <li className="style-97">
                    <div className="style-98">Comprovante de residência</div>
                  </li>
                  <li className="style-99">
                    <div className="style-100">Documentos de identidade (RG, CPF, CNH)</div>
                  </li>
                  <li className="style-101">
                    <div className="style-102">Atestado</div>
                  </li>
                  <li className="style-103">
                    <div className="style-104">Boards Miro</div>
                  </li>
                </ul>
              </li>
            </ul>
            <div className="style-105">
              <strong className="style-106">2.3.</strong> O uso de nossos serviços pode se dar por meio de
              nosso site ou aplicativo móvel. Nossos serviços permitem: agendamento de consulta com
              especialistas, avaliação de sua experiência, verificação do histórico de suas visitas e
              gerenciamento de sua conta de usuário. Em sua conta de usuário no aplicativo de celular, você
              pode gerenciar notificações push e outras notificações do sistema.
              <br className="style-107" />
              <br className="style-108" />
              <strong className="style-109">2.4.</strong> Os dados serão armazenados em nossa plataforma e
              transferidos ao profissional de saúde e/ou para a clínica que emprega o especialista. Uma vez
              que seus dados pessoais são transferidos para o profissional de saúde ou estabelecimento, este
              se torna, em acordo com a legislação, um controlador de dados que processará seus dados pessoais
              para seus próprios fins.
            </div>
            <div className="style-105">
              <strong className="style-106">2.5.</strong> Ao se cadastrar em nosso aplicativo, caso você
              conceda permissão por meio da funcionalidade de conectar o seu calendário, o aplicativo poderá
              acessar dados da sua conta Google Calendar (ou Google Agenda) exclusivamente com o objetivo de
              melhorar a sua experiência de usuário e fornecer nossos serviços, da seguinte forma:
              <ul>
                <br className="style-107" />
                <li>
                  - Acesso e uso: Poderemos acessar e usar dados de eventos do Google Calendar para
                  disponibilizar sua agenda como profisisonal de saúde para nossos pacientes para que os
                  mesmos possam fazer solicitações de agendamentos na sua agenda através da nossa aplicação.
                  Ao nos fornecer este acesso você estará nos dando acesso à dados da sua conta Google
                  Calendar que serão obtidos pelos seguintes escopos da API do Google Calendar:
                  <br className="style-108" />
                  <br className="style-108" />
                  <ul>
                    <li>
                      - Eventos do Calendário (somente leitura): Permitirá visualizar eventos em todos os seus
                      calendários. Esta permissão será utilizada pela nossa aplicação para detectar dias e
                      horários em que você tem eventos agendados e portanto, com base nisso, inferir sua
                      disponibilidade, que por sua vez será usada para criar uma agenda de horários
                      efetivamente disponíveis para solicitações agendamento, evitando solicitações que
                      resultem em conflito de horários, ou seja, dois eventos agendados no mesmo horário.
                      <br className="style-108" />
                      <br className="style-108" />
                    </li>
                    <li>
                      - Eventos do Calendário (gerenciamento de eventos): Permitirá visualizar, editar, criar
                      e excluir eventos em todos os seus calendários. Esta permissão será utilizada para criar
                      eventos em seu calendário a partir de solicitações de agendamento, bem como gerenciar
                      esses eventos quando necessário.
                      <br className="style-108" />
                      <br className="style-108" />
                    </li>
                  </ul>
                </li>
                <li>
                  - Armazenamento: Dados de eventos obtidos pela API do Google Calendar não serão armazenados
                  em nossos servidores e não serão lidos por humanos.
                  <br className="style-108" />
                  <br className="style-108" />
                </li>
                <li>
                  - Compartilhamento: Dados de eventos obtidos pela API do Google Calendar não serão
                  compartilhados.
                  <br className="style-108" />
                  <br className="style-108" />
                </li>
                <br className="style-108" />
                <li>
                  <strong>Segurança dos Dados:</strong> Implementamos rigorosas práticas de segurança para
                  proteger seus dados do Google Calendar, incluindo:
                  <ul>
                    <li>- Criptografia em trânsito e em repouso</li>
                    <li>- Controles de acesso estritos</li>
                    <li>- Monitoramento contínuo de segurança</li>
                    <li>- Auditorias regulares de segurança</li>
                  </ul>
                </li>
                <br className="style-108" />
                <li>
                  <strong>Não Utilizamos seus Dados Para:</strong>
                  <ul>
                    <li>- Publicidade ou marketing</li>
                    <li>- Venda ou transferência a terceiros</li>
                    <li>- Análise de crédito ou fins financeiros</li>
                    <li>- Qualquer finalidade além do agendamento</li>
                  </ul>
                </li>
              </ul>
            </div>
            <div
              className="google-limited-use-notice"
              style={{
                padding: "20px",
                margin: "20px 0",
                backgroundColor: "#f8f9fa",
                border: "2px solid #ddd",
                borderRadius: "4px",
                fontSize: "1.1em",
              }}>
              <strong>Aviso Importante sobre Uso de APIs do Google:</strong>
              <br />O uso e transferência para qualquer outro aplicativo de informações recebidas das APIs do
              Google pela Yinflow.Life aderirão à{" "}
              <a
                href="https://developers.google.com/terms/api-services-user-data-policy"
                target="_blank"
                rel="noopener noreferrer"
                className="style-7">
                Política de Dados do Usuário dos Serviços de API do Google
              </a>
              , incluindo os requisitos de Uso Limitado. Seus dados do Google Calendar são usados
              exclusivamente para fornecer as funcionalidades de agendamento e nunca serão vendidos, usados
              para publicidade ou compartilhados com terceiros.
            </div>
            <h4 className="style-110">3. Compartilhamento de Dados</h4>
            <div className="style-111">
              <strong className="style-112">3.1.</strong> Podemos divulgar seus dados pessoais para outras
              empresas que fazem parte da Yinflow.Life, seja por meio contratual ou afiliadas, apenas para
              fins de prestação de serviços para você. Também podemos compartilhar seus dados pessoais com
              provedores de terceiros, novamente apenas com o propósito de fornecer nossos serviços a você.
              <br className="style-113" />
              <br className="style-114" />
              <strong className="style-115">3.2.</strong> Exemplos de categorias de operadores de dados
              incluem:
              <br className="style-116" />
            </div>
            <ul role="list" className="style-117">
              <li className="style-118">
                <div className="style-119">Provedores de hospedagem em nuvem e manutenção de servidores</div>
              </li>
              <li className="style-120">
                <div className="style-121">Ferramentas de comunicação</div>
              </li>
              <li className="style-122">
                <div className="style-123">Ferramentas de suporte ao cliente</div>
              </li>
              <li className="style-124">
                <div className="style-125">Consultores externos, auditores ou conselheiros</div>
              </li>
              <li className="style-126">
                <div className="style-127">
                  Convênios e operadoras de saúde, prestadores de serviços de pagamento, bancos, agências de
                  referência de crédito e prevenção de fraudes e companhias de seguros
                </div>
              </li>
              <li className="style-128">
                <div className="style-129">Empresas de TI que nos fornecem software e serviços similares</div>
              </li>
              <li className="style-130">
                <div className="style-131">
                  Empresas que realizam a autorização de consultas e procedimentos por meio das operadoras de
                  planos de saúde
                </div>
              </li>
              <li className="style-132">
                <div className="style-133">
                  Empresas que permitem a emissão de receitas, prescrições eletrônicas e notas fiscais
                </div>
              </li>
            </ul>
            <div className="style-134">
              3.3. Podemos divulgar seus dados a fim de atender requisitos legais, fazer cumprir nossas{" "}
              <span className="style-135">políticas</span>, fazer contato com autoridades judiciais ou
              regulamentares, quando exigido pela lei aplicável, e proteger nossos direitos e propriedade.
              Também podemos compartilhar suas informações pessoais com outras entidades empresariais, caso
              planejemos nos fundir, receber investimentos ou ser adquiridos por uma entidade empresarial.
              <br className="style-136" />
            </div>
            <h4 className="style-137">4. Dados Anonimizados</h4>
            <div className="style-138">
              <strong className="style-139">4.1.</strong> Os dados sensíveis, em especial, os dados de saúde
              que você nos fornece serão anonimizados. A anonimização é uma técnica de processamento de dados
              que retira ou modifica dados que possam identificar uma pessoa, resultando em informações
              anonimizadas que não podem ser associadas a um indivíduo específico.
              <br className="style-140" />
              <br className="style-141" />
              <strong className="style-142">4.2.</strong> Com a análise de dados anonimizados, podemos criar
              produtos e recursos seguros e úteis para você, a partir da melhor compreensão das necessidades e
              preferências de nossos usuários. Podemos também compartilhar os dados anonimizados com outras
              pessoas, sem comprometer a privacidade de nossos clientes.
              <br className="style-143" />
              <br className="style-144" />
              <strong className="style-145">4.3.</strong> Alguns de nossos provedores (operadores de dados)
              estão baseados fora do Brasil, contudo, para podermos transferir seus dados pessoais para países
              terceiros, sempre garantimos que essas transferências atendam aos requisitos de segurança da
              Proteção de Dados Pessoais (LGPD), Lei nº 13.709, de 14/08/2018.
              <br className="style-146" />
            </div>
            <h4 className="style-147">5. Tempo de Processamento de Dados Pessoais</h4>
            <div className="style-148">
              <strong className="style-149">5.1.</strong> A qualquer momento, se você tiver alguma dúvida
              sobre seus dados pessoais, poderá entrar em contato conosco através dos nossos canais de
              comunicação. Você possui o direito de requerer a qualquer momento a eliminação dos dados
              submetidos, por e-mail:{" "}
              <a
                href="[mailto:dpo@yinflow.life](mailto:dpo@yinflow.life)?subject=Tempo%20de%20Processamento%20de%20Dados%20Pessoais"
                className="style-150">
                dpo@yinflow.life
              </a>{" "}
              ou por correspondência para o nosso endereço.
              <br className="style-151" />
              <br className="style-152" />
              <strong className="style-153">5.2.</strong> Nós apenas manteremos as informações que coletamos
              sobre você pelo tempo necessário para os propósitos acima estabelecidos ou conforme necessário
              para cumprir quaisquer obrigações legais às quais estamos sujeitos.
              <br className="style-154" />
              <br className="style-155" />
              <strong className="style-156">5.3.</strong> O período para o qual teremos informações sobre você
              variará dependendo do tipo de informação e dos propósitos para os quais as utilizamos. Em geral,
              manteremos nossos registros por até 5 anos depois que você terminar seu relacionamento conosco,
              a fim de cumprir com nossas obrigações legais. Para obter mais detalhes, consulte a tabela a
              seguir:
              <br className="style-157" />
            </div>
            <div className="style-158">
              <table className="style-159">
                <thead className="style-160">
                  <tr className="style-161">
                    <th className="style-162">Propósito de processamento</th>
                    <th className="style-163">Período de retenção</th>
                  </tr>
                </thead>
                <tbody className="style-164">
                  <tr className="style-165">
                    <td className="style-166">Fornecendo-lhe nossos serviços</td>
                    <td className="style-167">
                      Processaremos seus dados pessoais até que você tenha uma conta de usuário ou um contrato
                      de serviço ativo. Se você excluir sua conta de usuário ou contrato de serviço for
                      rescindido, processaremos seus dados pessoais pelo período adicional de 5 anos a partir
                      da data de exclusão.
                    </td>
                  </tr>
                  <tr className="style-168">
                    <td className="style-169">
                      Dados dos pacientes: Reservar uma visita ou organizar um exame médico
                    </td>
                    <td className="style-170">
                      Processaremos seus dados pessoais até que você tenha uma conta de usuário. Se você
                      excluir sua conta de usuário, processaremos seus dados pessoais pelo período adicional
                      de 5 anos.
                    </td>
                  </tr>
                  <tr className="style-171">
                    <td className="style-172">Informações técnicas e estatísticas</td>
                    <td className="style-173">
                      Processaremos seus dados pessoais até que você tenha uma conta de usuário. Se você
                      excluir sua conta de usuário, processaremos seus dados pessoais pelo período adicional
                      de 5 anos.
                    </td>
                  </tr>
                  <tr className="style-174">
                    <td className="style-175">Marketing</td>
                    <td className="style-176">
                      <div className="style-177">
                        Processaremos seus dados pessoais até que você retire seu consentimento para fins de
                        marketing, incluso nesta Política de Privacidade ou se oponha ao processamento de seus
                        dados pessoais. Para retirar o seu consentimento, entre em contato com{" "}
                        <a
                          href="[mailto:dpo@yinflow.life](mailto:dpo@yinflow.life)?subject=Pol%C3%ADtica%20de%20Privacidade%20%7C%20Marketing"
                          className="style-178">
                          dpo@yinflow.life
                        </a>
                        .
                      </div>
                    </td>
                  </tr>
                  <tr className="style-179">
                    <td className="style-180">Queixas</td>
                    <td className="style-181">
                      Processaremos seus dados pessoais por 5 anos depois que você tenha apresentado uma
                      reclamação.
                    </td>
                  </tr>
                  <tr className="style-182">
                    <td className="style-183">
                      Funcionalidade de armazenamento de dados de saúde para compartilhamento com
                      profissionais de saúde
                    </td>
                    <td className="style-184">
                      Os dados de saúde incluídos em seu perfil de saúde serão excluídos após a desativação da
                      conta ou se você revogar seu consentimento. O restante dos dados será mantido por 5 anos
                      após você excluir o Perfil de Saúde ou sua conta.
                    </td>
                  </tr>
                  <tr className="style-185">
                    <td className="style-186">Prontuários médicos</td>
                    <td className="style-187">
                      O tempo de guarda de prontuário médico no Brasil corresponde a 20 anos, conforme a Lei
                      13.787/18, que disciplina a digitalização e a utilização de sistemas informatizados para
                      a guarda, o armazenamento e o manuseio de prontuários de pacientes.
                    </td>
                  </tr>
                  <tr className="style-188">
                    <td className="style-189">O que é feito com meus dados depois de 20 anos?</td>
                    <td className="style-190">
                      Conforme Lei nº 13.787, de 27 de dezembro de 2018: "Art. 6º Decorrido o prazo mínimo de
                      20 (vinte) anos a partir do último registro, os prontuários em suporte de papel e os
                      digitalizados poderão ser eliminados. § 1º Prazos diferenciados para a guarda de
                      prontuário de paciente, em papel ou digitalizado, poderão ser fixados em regulamento, de
                      acordo com o potencial de uso em estudos e pesquisas nas áreas das ciências da saúde,
                      humanas e sociais, bem como para fins legais e probatórios. § 2º Alternativamente à
                      eliminação, o prontuário poderá ser devolvido ao paciente. § 3º O processo de eliminação
                      deverá resguardar a intimidade do paciente e o sigilo e a confidencialidade das
                      informações. § 4º A destinação final de todos os prontuários e a sua eliminação serão
                      registradas na forma de regulamento. § 5º As disposições deste artigo aplicam-se a todos
                      os prontuários de paciente, independentemente de sua forma de armazenamento, inclusive
                      aos microfilmados e aos arquivados eletronicamente em meio óptico, bem como aos
                      constituídos por documentos gerados e mantidos originalmente de forma eletrônica."
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <h4 className="style-191">6. Política de Cookies</h4>
            <div className="style-192">
              <strong className="style-193">6.1.</strong> Cookies são pequenos arquivos baixados em seu
              computador ou outro dispositivo que você usa para navegar em nosso site. A maioria dos sites usa
              cookies. Normalmente, um cookie inclui as seguintes informações: o nome do site de onde ele
              veio; quanto tempo o cookie ficará no seu computador ou dispositivo; e um valor (geralmente um
              número único gerado aleatoriamente). Alguns cookies podem incluir dados adicionais, em
              particular relacionados ao seu fuso horário ou idioma usado para navegação.
              <br className="style-194" />
              <br className="style-195" />
              <strong className="style-196">6.2.</strong> Este tópico descreve quais informações coletamos,
              como as usamos e por que às vezes precisamos armazenar cookies. Também compartilharemos como
              você pode impedir que esses cookies sejam armazenados, no entanto, isso pode rebaixar ou tornar
              certos elementos da funcionalidade do site disfuncionais.
              <br className="style-197" />
              <br className="style-198" />
              <strong className="style-199">6.3.</strong> Alguns cookies estão sempre ligados quando você nos
              visita e você não pode desligá-los a menos que altere as configurações do seu navegador.
              Chamamos estes de cookies necessários. Nós os usamos para garantir que nossos serviços digitais
              funcionem corretamente e permitam o uso de funcionalidades, como login do usuário, gerenciamento
              de contas e persistência de dados e estados do sistema.
              <br className="style-200" />
              <br className="style-201" />
              <strong className="style-202">6.4.</strong> Também usamos cookies funcionais para tornar sua
              experiência mais amigável, em particular para lembrar e armazenar suas informações em nossos
              sites e personalizar o conteúdo de nossos serviços.
              <br className="style-203" />
              <br className="style-204" />
              <strong className="style-205">6.5.</strong> Também usamos cookies de desempenho para observar
              como nossos serviços são usados e obter estatísticas de uso.
              <br className="style-206" />
              <br className="style-207" />
              <strong className="style-208">6.6.</strong> Também usamos cookies de terceiros. Esses cookies
              podem rastrear como você usa sites diferentes, incluindo o nosso. Por exemplo, você pode obter
              os cookies de uma empresa de mídia social quando registra em nosso site usando um plugin de
              mídia social para autenticação ou quando simplesmente visita um site contendo geradores desses
              cookies. Caso deseje, você pode desativar esses cookies de marketing, conforme disposto em nosso
              site. Caso deseje, você pode desativar esses cookies, contando, ainda, com acesso ao nosso Data
              Protection Officer da Yinflow.Life disponível no endereço de e-mail:{" "}
              <a
                href="[mailto:dpo@yinflow.life](mailto:dpo@yinflow.life)?subject=Pol%C3%ADtica%20de%20Cookies"
                className="style-209">
                dpo@yinflow.life
              </a>
              .<br className="style-210" />
            </div>
            <h4 className="style-211">7. Como Usamos Cookies</h4>
            <div className="style-212">
              <strong className="style-213">7.1.</strong> Usamos cookies por uma variedade de razões
              detalhadas abaixo. Para aproveitar melhor o nosso site, recomendamos que você configure seu
              dispositivo para aceitar todos os cookies. No entanto, usando as configurações do seu
              dispositivo, você pode desativar ou limitar certos tipos de cookies. Nós usamos cookies para:
              <br className="style-214" />
            </div>
            <ul role="list" className="style-215">
              <li className="style-216">
                <div className="style-217">
                  <strong className="style-218">Fornecer-lhe uma melhor experiência:</strong> os cookies são
                  usados para melhorar sua experiência online. Eles podem ajudar de diferentes maneiras,
                  incluindo: garantir que nossos sites carreguem mais rápido, mantê-lo conectado, mesmo em
                  diferentes dispositivos, tornar os logins mais rápidos e acessíveis, lembrar seus dados,
                  lembrar a maneira como você usou nosso serviço anteriormente, permitindo que você agende uma
                  consulta ou sessão com um profissional de saúde de forma mais rápida e acessível, ou
                  certificando-se de que nossas páginas são otimizadas para o seu navegador ou dispositivo.
                </div>
              </li>
              <li className="style-219">
                <div className="style-220">
                  <strong className="style-221">Ajustar nossos serviços às suas preferências:</strong> os
                  cookies podem nos ajudar a apresentar-lhe conteúdo que atenda melhor aos seus interesses e
                  preferências. Os cookies também nos ajudam a personalizar nosso site para você.
                </div>
              </li>
              <li className="style-222">
                <div className="style-223">
                  <strong className="style-224">Aprimorar a segurança:</strong> usamos alguns cookies para
                  garantir a segurança de nossa plataforma.
                </div>
              </li>
              <li className="style-225">
                <div className="style-226">
                  <strong className="style-227">Melhorar nossos sites:</strong> usamos cookies para melhorar
                  nossos serviços e prever a maneira como os usuários usam nossos sites para torná-los
                  melhores para nossos usuários.
                </div>
              </li>
              <li className="style-228">
                <div className="style-229">
                  <strong className="style-230">Marketing:</strong> usamos alguns cookies para informar
                  algoritmos de anúncios de nossos serviços e outras plataformas. Usamos esses cookies em
                  cooperação com nossos parceiros de marketing (Google e Meta).
                </div>
              </li>
            </ul>
            <div className="style-231">
              <strong className="style-232">7.2.</strong> Usamos Cookies de Terceiros para perseguir nossos
              interesses legítimos e tornar nossos sites melhores para nossos usuários. A seguir detalhamos
              mais sobre esse compartilhamento.
              <br className="style-233" />
            </div>
            <ul role="list" className="style-234">
              <li className="style-235">
                <div className="style-236">
                  Usamos o Google Analytics - Usamos o Google Analytics. O Google Analytics é amplamente
                  utilizado por sites em todo o mundo. Esta ferramenta nos ajuda a entender, prever e ajustar
                  nossos sites para nossos usuários e nos ajuda a gerenciar nossas bases de dados e melhorar
                  nosso SEO (Search Engine Optimization).
                </div>
              </li>
              <li className="style-237">
                <div className="style-238">
                  Outras plataformas de anúncios e análise de dados, interligadas ao Google Analytics por meio
                  da ferramenta Google Tag Manager. O processamento de cookies por estas ferramentas tem o
                  exclusivo propósito de nos ajudar a saber se o conteúdo que nós fornecemos por meio de
                  nossos canais de comunicação é interessante para você e também para podermos personalizar o
                  conteúdo de nossa comunicação .
                </div>
              </li>
              <li className="style-239">
                <div className="style-240">
                  Também usamos cookies de terceiros para medir o uso do nosso site. Em particular, esses
                  cookies podem registrar quanto tempo você gasta em nosso site e como você navega.
                </div>
              </li>
              <li className="style-241">
                <div className="style-242">
                  Também usamos cookies de terceiros para testar nossos novos recursos e produtos. Esses
                  cookies nos ajudam a garantir que você receba uma experiência consistente de nossos
                  serviços.
                </div>
              </li>
              <li className="style-243">
                <div className="style-244">
                  Também usamos botões de autenticação por mídia social e/ou contas de sites de terceiros.
                  Para que estas funcionalidades operem corretamente, é necessária a escrita e leitura de
                  cookies.
                </div>
              </li>
              <li className="style-245">
                <div className="style-246">
                  Usamos soluções técnicas fornecidas pelo Meta, Google e outros para melhor adaptar nossos
                  serviços e oferecer uma melhor experiência ao usuário em nosso site e melhor performance das
                  nossas comunicações nessas plataformas.
                </div>
              </li>
            </ul>
            <div className="style-247">
              <strong className="style-248">7.3.</strong> Dependendo do tipo de cookie, alguns deles são
              armazenados durante um curto período, enquanto outros são armazenados por períodos mais longos.
              <br className="style-249" />
            </div>
            <div className="style-250">
              <table className="style-251">
                <thead className="style-252">
                  <tr className="style-253">
                    <th className="style-254">Cookie</th>
                    <th className="style-255">Data de Validade</th>
                  </tr>
                </thead>
                <tbody className="style-256">
                  <tr className="style-257">
                    <td className="style-258">...</td>
                    <td className="style-259">...</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="style-260">
              <strong className="style-261">7.4.</strong> Utilizamos cookies de sessão - esses cookies
              autenticam seu navegador em nossos sistemas, e caso você esteja usando um computador ou celular
              compartilhado, recomendamos que exclua os cookies de seu navegador ao terminar sua sessão.
              <br className="style-262" />
              <br className="style-263" />
              <strong className="style-264">7.5.</strong> Utilizamos cookies persistentes - esses cookies
              permanecem armazenados mesmo que o seu navegador seja fechado ou seu dispositivo seja desligado,
              e estão ativos por um tempo definido no cookie. Usamos cookies persistentes quando precisamos
              saber quem você é para mais de uma sessão de navegação. Por exemplo, usamos para lembrar suas
              preferências para a próxima vez que você visitar ou caso tenha realizado o agendamento de uma
              consulta.
              <br className="style-265" />
              <br className="style-266" />
              <strong className="style-267">7.6.</strong> Você pode impedir a configuração de cookies
              ajustando as configurações do seu navegador. Você pode encontrar instruções sobre como fazer
              isso na tabela abaixo. Esteja ciente de que a desativação de cookies afetará a funcionalidade
              deste e de muitos outros sites que você visitar. A desativação de cookies geralmente resultará
              também na desativação de certas funcionalidades e recursos de nossos serviços. Portanto,
              recomenda-se que você não desabilite cookies para não prejudicar as funcionalidades. Caso deseje
              fazê-lo, poderá gerenciá-los da seguinte forma:
              <br className="style-268" />
            </div>
            <div className="style-269">
              <table className="style-270">
                <thead className="style-271">
                  <tr className="style-272">
                    <th className="style-273">Navegador</th>
                    <th className="style-274">Link para Configurações</th>
                    <th className="style-275">Como você pode gerenciar cookies</th>
                  </tr>
                </thead>
                <tbody className="style-276">
                  <tr className="style-277">
                    <td className="style-278">Google Chrome</td>
                    <td className="style-279">
                      <div className="style-280">
                        <a
                          href="https://support.google.com/accounts/answer/32050?hl=pt-BR"
                          target="_blank"
                          className="style-281">
                          https://support.google.com/accounts/answer/32050?hl=pt-BR
                        </a>
                      </div>
                    </td>
                    <td className="style-282">
                      Você deve clicar em três pontos que estão no canto superior do lado direito e abrir
                      "configurações". No site de configuração, clique em "segurança e privacidade" para
                      gerenciar cookies.
                    </td>
                  </tr>
                  <tr className="style-283">
                    <td className="style-284">Safari</td>
                    <td className="style-285">
                      <div className="style-286">
                        <a
                          href="https://support.apple.com/pt-br/105082"
                          target="_blank"
                          className="style-287">
                          https://support.apple.com/pt-br/105082
                        </a>
                      </div>
                    </td>
                    <td className="style-288">
                      Você deve ir para a página de configurações "preferências" e clicar em "segurança". Na
                      seção "segurança", você pode gerenciar seus cookies.
                    </td>
                  </tr>
                  <tr className="style-289">
                    <td className="style-290">Microsoft Edge</td>
                    <td className="style-291">
                      <div className="style-292">
                        <a
                          href="https://support.microsoft.com/pt-br/windows/gerenciar-cookies-no-microsoft-edge-exibir-permitir-bloquear-excluir-e-usar-168dab11-0753-043d-7c16-ede5947fc64d"
                          target="_blank"
                          className="style-293">
                          https://support.microsoft.com/pt-br/windows/gerenciar-cookies-no-microsoft-edge-exibir-permitir-bloquear-excluir-e-usar-168dab11-0753-043d-7c16-ede5947fc64d
                        </a>
                      </div>
                    </td>
                    <td className="style-294">
                      Você deve clicar em três pontos que estão no canto superior do lado direito e abrir
                      "configurações". No site de configuração, clique em "privacidade, pesquisa e serviços"
                      para gerenciar cookies.
                    </td>
                  </tr>
                  <tr className="style-295">
                    <td className="style-296">Mozilla Firefox</td>
                    <td className="style-297">
                      <div className="style-298">
                        <a
                          href="https://support.mozilla.org/pt-BR/kb/limpe-cookies-e-dados-de-sites-no-firefox"
                          target="_blank"
                          className="style-299">
                          https://support.mozilla.org/pt-BR/kb/limpe-cookies-e-dados-de-sites-no-firefox
                        </a>
                      </div>
                    </td>
                    <td className="style-300">
                      Você deve clicar em três barras que estão no canto superior do lado direito e abrir
                      "opções". No site de opções, clique em "segurança e privacidade" para gerenciar cookies.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <h4 className="style-301">8. Como Obter uma Cópia dos Meus Dados</h4>
            <div className="style-302">
              <strong className="style-303">8.1.</strong> Para obter uma cópia de algum(s) dado(s) pessoal seu
              em nossas bases de dados, entre em contato com{" "}
              <a
                href="[mailto:dpo@yinflow.life](mailto:dpo@yinflow.life)?subject=Como%20obter%20uma%20c%C3%B3pia%20dos%20meus%20dados"
                className="style-304">
                dpo@yinflow.life
              </a>{" "}
              a partir de um email que você já tenha usado em nossos sites.
              <br className="style-305" />
            </div>
            <h4 className="style-306">9. Como Deletar os Meus Dados</h4>
            <div className="style-307">
              <strong className="style-308">9.1.</strong> Aqui, você poderá entender melhor como exercer seus
              direitos previstos pela Lei Geral de Proteção de Dados Pessoais (LGPD) e a condição para a
              portabilidade dos prontuários dos pacientes.
              <br className="style-309" />
              <br className="style-310" />
              <strong className="style-311">9.2.</strong> O usuário poderá ter acesso aos seus dados e
              solicitar a retificação dos mesmos por meio de solicitação formal feita a partir do email
              associado aos dados em questão para o endereço de email{" "}
              <a
                href="[mailto:dpo@yinflow.life](mailto:dpo@yinflow.life)?subject=Como%20deletar%20meus%20dados"
                className="style-312">
                dpo@yinflow.life
              </a>
              .<br className="style-313" />
              <br className="style-314" />
              <strong className="style-315">9.3.</strong> Pelo canal de atendimento da YINFLOW, o USUÁRIO
              poderá também requerer: (i) a limitação do uso de seus dados pessoais; (ii) manifestar sua
              oposição ao uso de seus dados pessoais; ou (iii) solicitar a eliminação de seus dados pessoais
              coletados pela YINFLOW, desde que a eventual relação contratual entre o USUÁRIO e a YINFLOW
              tenha terminado, que não haja nenhuma finalidade de uso que legitime o tratamento e que tenha
              decorrido o prazo legal mínimo relacionado à retenção dos dados.
              <br className="style-316" />
              <br className="style-317" />
              <strong className="style-318">9.4.</strong> Tendo em vista o papel de Operador que a
              Yinflow.Life desempenha em relação aos dados de pacientes, a portabilidade dos dados de
              prontuários médicos deverá ser solicitada pelo próprio paciente ao profissional de saúde que o
              atende ou à clínica em que realiza tratamento de saúde, responsável pela guarda dos dados dos
              prontuários.
              <br className="style-319" />
              <br className="style-320" />
              <strong className="style-321">9.5.</strong> A Yinflow.Life trata os dados pessoais conforme as
              melhores práticas de segurança da informação e, em especial, os armazena na nuvem da Amazon Web
              Services, que aplica as mais avançadas técnicas de segurança da informação disponíveis no
              mercado, sendo certificada no atendimento a todos os requisitos de segurança determinados pela
              ISO 27018, o código de melhores práticas internacionais para proteção de dados pessoais na nuvem
              e outros. A lista completa de certificados e protocolos aderidos pela Amazon Web Services está
              disponível em:{" "}
              <a href="https://aws.amazon.com/compliance/" target="_blank" className="style-322">
                AWS Compliance
              </a>
              .<br className="style-323" />
              <br className="style-324" />
              <strong className="style-325">9.6.</strong> A própria Yinflow.Life também aplica medidas
              técnicas e administrativas aptas a proteger os dados pessoais de acessos não autorizados e de
              situações acidentais ou ilícitas de destruição, perda, alteração, comunicação ou difusão,
              observados a estrutura, a escala e o volume de suas operações, bem como a sensibilidade dos
              dados tratados e a probabilidade e a gravidade dos danos para os titulares dos dados. Dentre
              tais medidas, destaca-se o uso de técnicas de SALT, CAPTCHAs para a codificação da senha,
              backup, anonimização, segregação dos dados e controle de acesso aos dados com base na
              necessidade e permissão concedida pelo USUÁRIO.
              <br className="style-326" />
            </div>
            <div className="style-327">
              <strong className="style-328">7.4.</strong> Utilizamos cookies de sessão - esses cookies
              autenticam seu navegador em nossos sistemas, e caso você esteja usando um computador ou celular
              compartilhado, recomendamos que exclua os cookies de seu navegador ao terminar sua sessão.
              <br className="style-329" />
              <br className="style-330" />
              <strong className="style-331">7.5.</strong> Utilizamos cookies persistentes - esses cookies
              permanecem armazenados mesmo que o seu navegador seja fechado ou seu dispositivo seja desligado,
              e estão ativos por um tempo definido no cookie. Usamos cookies persistentes quando precisamos
              saber quem você é para mais de uma sessão de navegação. Por exemplo, usamos para lembrar suas
              preferências para a próxima vez que você visitar ou caso tenha realizado o agendamento de uma
              consulta.
              <br className="style-332" />
              <br className="style-333" />
              <strong className="style-334">7.6.</strong> Você pode impedir a configuração de cookies
              ajustando as configurações do seu navegador. Você pode encontrar instruções sobre como fazer
              isso na tabela abaixo. Esteja ciente de que a desativação de cookies afetará a funcionalidade
              deste e de muitos outros sites que você visitar. A desativação de cookies geralmente resultará
              também na desativação de certas funcionalidades e recursos de nossos serviços. Portanto,
              recomenda-se que você não desabilite cookies para não prejudicar as funcionalidades. Caso deseje
              fazê-lo, poderá gerenciá-los da seguinte forma:
              <br className="style-335" />
            </div>
            <h4 className="style-336">10. Disposições Gerais</h4>
            <div className="style-337">
              <strong className="style-338">10.1.</strong> Aqui, você encontrará algumas informações gerais,
              como, por exemplo, o contato do Data Protection Officer (e-mail:{" "}
              <a
                href="[mailto:dpo@yinflow.life](mailto:dpo@yinflow.life)?subject=Data%20Protection%20Officer"
                className="style-339">
                dpo@yinflow.life
              </a>
              ) da Yinflow.Life e que, se uma cláusula for julgada inválida, as demais automaticamente
              permanecerão válidas, sem necessidade de nova comunicação.
              <br className="style-340" />
              <br className="style-341" />
              <strong className="style-342">10.2.</strong> A Yinflow.Life não utiliza nenhum tipo de decisão
              automatizada que impacte o USUÁRIO.
              <br className="style-343" />
              <br className="style-344" />
              <strong className="style-345">10.3.</strong> A Yinflow.Life reserva a si o direito de alterar o
              teor desta <span className="style-346">Política de Privacidade</span> a qualquer momento,
              conforme a finalidade ou necessidade, tal qual para adequação e conformidade legal de disposição
              de lei ou norma que tenha força jurídica equivalente, cabendo ao USUÁRIO verificá-la sempre que
              acessar a Yinflow.Life.
              <br className="style-347" />
              <br className="style-348" />
              <strong className="style-349">10.4.</strong> Ocorrendo atualizações neste documento e que
              necessariamente demandam nova coleta de consentimento, a Yinflow.Life notificará o USUÁRIO pelos
              meios de contato fornecidos pelo mesmo.
              <br className="style-350" />
              <br className="style-351" />
              <strong className="style-352">10.5.</strong> Em caso de qualquer dúvida com relação às
              disposições constantes nesta <span className="style-353">Política de Privacidade</span> ou
              necessidade de contato com o Encarregado pelo Tratamento de Dados Pessoais (Data Protection
              Officer - DPO) da Yinflow.Life, o USUÁRIO poderá entrar em contato pelo Canal de Atendimento ao
              Titular pelo endereço de e-mail{" "}
              <a
                href="[mailto:dpo@yinflow.life](mailto:dpo@yinflow.life)?subject=Tratamento%20de%20Dados%20Pessoais"
                className="style-354">
                dpo@yinflow.life
              </a>
              .<br className="style-355" />
              <br className="style-356" />
              <strong className="style-357">10.6.</strong> Caso empresas terceirizadas realizem o tratamento
              de quaisquer dados coletados pela Yinflow.Life, elas deverão respeitar as condições aqui
              estipuladas e as melhores práticas de segurança da informação.
              <br className="style-358" />
              <br className="style-359" />
              <strong className="style-360">10.7.</strong> Caso alguma disposição desta{" "}
              <span className="style-361">Política de Privacidade</span> seja considerada ilegal ou ilegítima
              por autoridade da localidade em que o USUÁRIO resida, as demais condições permanecerão em pleno
              vigor e produção de efeitos.
              <br className="style-362" />
              <br className="style-363" />
              <strong className="style-364">10.8.</strong> O USUÁRIO reconhece que toda comunicação realizada
              por qualquer forma eletrônica é válida como prova documental, sendo eficaz e suficiente para a
              divulgação de qualquer assunto a que se refere, aos serviços prestados pela Yinflow.Life, bem
              como às condições de sua prestação ou a qualquer outro assunto nele abordado, ressalvadas as
              disposições expressamente diversas previstas nesta{" "}
              <span className="style-365">Política de Privacidade</span>.<br className="style-366" />
            </div>
            <h4 className="style-367">11. Informações, Dúvidas, Sugestões e Reclamações</h4>
            <div className="style-368">
              <strong className="style-369">11.1.</strong> Em casos de informações, dúvidas, sugestões e
              reclamações, referentes a assuntos não relacionados a dados, os usuários poderão entrar em
              contato com a Yinflow.Life através do e-mail{" "}
              <a
                href="[mailto:falecom@yinflow.life](mailto:falecom@yinflow.life)?subject=Informa%C3%A7%C3%B5es%2C%20D%C3%BAvidas%2C%20Sugest%C3%B5es%20e%20Reclama%C3%A7%C3%B5es"
                className="style-370">
                falecom@yinflow.life
              </a>
              , onde os e-mails serão respondidos no horário comercial de segunda a sexta em até 72 horas.
              <br className="style-371" />
            </div>
            <h4 className="style-372">12. Lei Aplicável e Jurisdição</h4>
            <div className="style-373">
              <strong className="style-374">12.1.</strong> O presente documento será regido e interpretado
              segundo a legislação brasileira, no idioma português, sendo eleito o foro do domicílio da Cidade
              de São Paulo no que diz respeito aos dados e Aplicação da LGPD e o foro da comarca da Capital
              para dirimir qualquer litígio ou controvérsia envolvendo o presente documento, salvo ressalva
              específica de competência pessoal, territorial ou funcional pela legislação aplicável.
              <br className="style-375" />
              <br className="style-376" />
              12.2. O usuário fica ciente que os serviços prestados fora do território brasileiro terão a sua
              jurisdição e aplicação de leis, o foro do país da compra ou prestação de serviços que serão
              contratados fora da jurisdição brasileira.
              <br className="style-377" />
              <br className="style-378" />
              12.3. Exceto em casos em que for indicado o contrário, a empresa estrangeira YINFLOW LLC,
              parceira da YINFLOW LTDA detém direitos à propriedade intelectual de todo material proprietário,
              postado nas ferramentas e aplicativos Yinflow.Life, operados pela YINFLOW LTDA e profissionais
              de saúde parceiros, pois a mesma detém todos os direitos à propriedade intelectual reservados na
              forma da lei.
              <br className="style-379" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Policy;
